export default __webpack_public_path__ + "static/media/paavai_logo.6a0c118d.png";